import { useContext, useEffect, useState } from "react";
import { config, searchRegex, statusOption } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext, NavigatorContext } from "../../../../context";

export const useJobsList = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const Actor = useElement("Actor");
  const CheckBox = useElement("CheckBox");
  const Img = useElement("Img");
  const { fetchAll, remove, update, save } = useService("Data", "job");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { generateUID, showAlert, getFormattedDate, isBottom } =
    useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const { commonPageSize } = config;
  const filterTags = statusOption;
  const [tableContent, settableContent] = useState(null);
  const [tableData, settableData] = useState([]);
  const [activeItem, setactiveItem] = useState(null);
  const [filteredList, setfilteredList] = useState([]);
  const [checkedList, setcheckedList] = useState([]);
  const [searchKey, setsearchKey] = useState<string>("");
  const [activeFilterIndex, setactiveFilterIndex] = useState<number>(0);
  const [showTrashConfirm, setshowTrashConfirm] = useState<boolean>(false);
  const [trashAction, settrashAction] = useState<boolean>(false);
  const [isMultipleDelete, setisMultipleDelete] = useState<boolean>(false);
  const [checkedAll, setcheckedAll] = useState<boolean>(false);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [activeFilter, setactiveFilter] = useState(filterTags[0]);

  setTitle(t("jobsList"), "admin");
  useEffect(() => {
    const urlData = urlToSplitData(getLocationData().pathname);
    settrashAction(urlData[2] === "trash");
    getJobsListData();
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getJobsListData = async () => {
    const result = await fetchAll();
    if (result.status) {
      let tableData = [];
      result.data.forEach((e) => {
        if (!trashAction) {
          if (!e.trash) tableData.push(e);
        } else {
          if (e.trash) tableData.push(e);
        }
      });
      settableData(tableData);
      setfilteredList(tableData);
      let activefilterValue = "all";
      filterTags.forEach((e) => {
        if (Number(e.id) === activeFilterIndex + 1) {
          activefilterValue = e.value;
        }
      });
      filterItems(activefilterValue, activeFilterIndex);
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: "No jobs added yet!" });
      }
    } else showAlert({ type: "error", msg: "No jobs added yet!" });
  };

  const trashCancel = () => {
    setactiveItem(null);
    setshowTrashConfirm(false);
  };

  const deleteSelectedJob = () => {
    deleteJob(activeItem.uid);
  };

  const deleteJob = async (uid, task = "trash") => {
    if (trashAction && task === "trash") {
      const result = await remove({ uid });
      if (result.status) {
        getJobsListData();
        showAlert({ type: "success", msg: "Job deleted successfully!" });
        setactiveItem(null);
        setshowTrashConfirm(false);
        getJobsListData();
      } else showAlert({ type: "error", msg: "Unable to delete job!" });
    } else {
      let jobObject = null;
      tableData.forEach((e) => {
        if (e.uid === uid) {
          jobObject = e;
        }
      });
      jobObject.trash = task === "trash";
      delete jobObject._id;
      let data = {
        query: JSON.stringify({ uid }),
        jobData: JSON.stringify(jobObject),
      };
      const result = await update(data);
      if (result.status) {
        showAlert({ type: "success", msg: "Job " + task + "d successfully!" });
        setactiveItem(null);
        setshowTrashConfirm(false);
        getJobsListData();
      } else showAlert({ type: "error", msg: "Unable to " + task + " job!" });
    }
  };

  useEffect(() => {
    setcheckedAll(filteredList.length === checkedList.length);
  }, [filteredList, checkedList]);

  const toggleCheck = (uid) => {
    if (checkedList.includes(uid)) {
      setcheckedList(checkedList.filter((e) => e !== uid));
    } else {
      setcheckedList([...checkedList, uid]);
    }
  };

  const deleteChecked = () => {
    (checkedAll ? filteredList : checkedList).forEach((e) => {
      deleteJob(e.uid);
    });
    setcheckedList([]);
    setisMultipleDelete(false);
  };

  const cloneJob = async (item) => {
    let jobObject = {
      ...item,
      slug: item.slug + "-copy",
      uid: generateUID(),
    };
    const result = await save(jobObject);
    if (result.status) {
      showAlert({ type: "success", msg: "Job clonsed successfully!" });
      getJobsListData();
    } else showAlert({ type: "error", msg: "Unable to add job!" });
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.map((item) => {
      let e = {
        checkAction: (
          <span className="check-all" onClick={() => toggleCheck(item.uid)}>
            <CheckBox
              isChecked={checkedAll || checkedList.includes(item.uid)}
            />
          </span>
        ),
        title: item.title,
        image: item.image ? (
          <Img
            src={JSON.parse(item.image)[0]}
            style={{ maxHeight: 40, maxWidth: 40 }}
          />
        ) : (
          <p>{t("noImage")}</p>
        ),
        publishDate: getFormattedDate(new Date(item.publishDate)),
        status: item.status,
        action: trashAction ? (
          <div className="action-bar">
            <Actor
              type="trash"
              onClick={() => {
                setactiveItem(item);
                setshowTrashConfirm(true);
              }}
            />
            <Actor type="undo" onClick={() => deleteJob(item.uid, "restore")} />
          </div>
        ) : (
          <div className="action-bar">
            <Actor
              type="trash"
              onClick={() => {
                setactiveItem(item);
                setshowTrashConfirm(true);
              }}
            />
            <Actor
              type="view"
              onClick={() =>
                navigateTo({ route: "/job/" + item.slug, newtab: true })
              }
            />
            <Actor
              type="edit"
              onClick={() =>
                navigateTo({ route: "/admin/job/edit/" + item.uid })
              }
            />
            <Actor type="copy" onClick={() => cloneJob(item)} />
          </div>
        ),
      };
      data.push(e);
    });
    return data;
  };

  const filterItems = (key, activeFilterIndex) => {
    const filteredList =
      key === "all" ? tableData : tableData.filter((e) => e.status === key);
    setfilteredList(filteredList);
    setactiveFilterIndex(activeFilterIndex);
  };

  const resetSearch = () => {
    setfilteredList(tableData);
    setsearchKey("");
  };

  const search = (e) => {
    if (e.target.value === "" || searchRegex.test(e.target.value)) {
      setsearchKey(e.target.value);
      let tempTitle = "",
        filteredList = [];
      tableData.forEach((e) => {
        tempTitle = e.title.toLowerCase();
        if (tempTitle.search(searchKey) !== -1) filteredList.push(e);
      });
      setfilteredList(filteredList);
    }
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          template: (
            <span
              className="check-all"
              onClick={() => {
                let newCheckedList = [];
                if (checkedAll) {
                  setcheckedAll(!checkedAll);
                  setcheckedList([]);
                } else {
                  filteredList.forEach((e) => newCheckedList.push(e.uid));
                  setcheckedAll(!checkedAll);
                  setcheckedList(newCheckedList);
                }
              }}
            >
              <CheckBox
                isChecked={
                  checkedAll ||
                  (checkedList.length === filteredList.length &&
                    filteredList.length !== 0)
                }
              />
            </span>
          ),
        },
        {
          label: t("title"),
          key: "title",
        },
        {
          label: t("image"),
          key: "image",
        },
        {
          label: t("publishDate"),
          key: "publishDate",
        },
        {
          label: t("status"),
          key: "status",
        },
        {
          label: t("actions"),
          key: "actions",
        },
      ],
      content: getTableData(filteredList),
    });
  }, [filteredList, checkedAll, checkedList]);
  return {
    trackScrolling,
    trashAction,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    activeFilter,
    setactiveFilter,
    filterItems,
    filterTags,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
    deleteChecked,
    deleteSelectedJob,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  };
};
